import { render, staticRenderFns } from "./mdVideo.vue?vue&type=template&id=2fe2ac7f&scoped=true&"
import script from "./mdVideo.vue?vue&type=script&lang=js&"
export * from "./mdVideo.vue?vue&type=script&lang=js&"
import style0 from "./mdVideo.vue?vue&type=style&index=0&id=2fe2ac7f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe2ac7f",
  null
  
)

export default component.exports